module.exports = __webpack_public_path__ + "img/company.159f99d5.png";